"use client";

import { c as _c } from "react/compiler-runtime";
import { PlusIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveCurations } from "@/hooks/waves/useWaveCurations";
import MyStreamActionTooltip from "../MyStreamActionTooltip";
import MyStreamWaveCurationCreateDialog from "./MyStreamWaveCurationCreateDialog";
import { useState } from "react";
interface MyStreamWaveCreateCurationActionProps {
  readonly wave: ApiWave;
  readonly onCreated: (curationId: string) => void;
  readonly className?: string | undefined;
}
export default function MyStreamWaveCreateCurationAction(t0) {
  const $ = _c(32);
  const {
    wave,
    onCreated,
    className
  } = t0;
  let t1;
  if ($[0] !== wave.id) {
    t1 = {
      waveId: wave.id
    };
    $[0] = wave.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: t2
  } = useWaveCurations(t1);
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const curations = t3;
  const canManageCurations = wave.wave.authenticated_user_eligible_for_admin === true;
  const [isCreateCurationOpen, setIsCreateCurationOpen] = useState(false);
  if (!canManageCurations) {
    return null;
  }
  const createCurationTooltipId = `my-stream-create-curation-${wave.id}`;
  const showCreateFirstCurationCallout = curations.length === 0;
  let t4;
  if ($[4] !== createCurationTooltipId || $[5] !== showCreateFirstCurationCallout) {
    t4 = showCreateFirstCurationCallout ? {} : {
      "data-tooltip-id": createCurationTooltipId,
      "data-tooltip-content": "Create curation"
    };
    $[4] = createCurationTooltipId;
    $[5] = showCreateFirstCurationCallout;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const createButtonTooltipProps = t4;
  let t5;
  if ($[7] !== className) {
    t5 = clsx("tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsCreateCurationOpen(true);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = showCreateFirstCurationCallout ? "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-text-xs tw-font-semibold tw-text-iron-100 tw-transition desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-white md:tw-h-auto md:tw-w-auto md:tw-gap-2 md:tw-rounded-lg md:tw-px-3.5 md:tw-py-2" : "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-text-iron-200 tw-transition desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-white";
  const t8 = `tw-h-4 tw-w-4 tw-flex-shrink-0 ${showCreateFirstCurationCallout ? "md:-tw-ml-1" : ""}`;
  let t9;
  if ($[10] !== t8) {
    t9 = <PlusIcon className={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== showCreateFirstCurationCallout) {
    t10 = showCreateFirstCurationCallout && <span className="tw-hidden tw-whitespace-nowrap md:tw-inline">Create first curation</span>;
    $[12] = showCreateFirstCurationCallout;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== createButtonTooltipProps || $[15] !== t10 || $[16] !== t7 || $[17] !== t9) {
    t11 = <button type="button" onClick={t6} {...createButtonTooltipProps} className={t7} aria-label="Create curation">{t9}{t10}</button>;
    $[14] = createButtonTooltipProps;
    $[15] = t10;
    $[16] = t7;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t5) {
    t12 = <div className={t5}>{t11}</div>;
    $[19] = t11;
    $[20] = t5;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== createCurationTooltipId) {
    t13 = <MyStreamActionTooltip id={createCurationTooltipId} />;
    $[22] = createCurationTooltipId;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isCreateCurationOpen || $[25] !== onCreated || $[26] !== wave) {
    t14 = isCreateCurationOpen && <MyStreamWaveCurationCreateDialog wave={wave} isOpen={isCreateCurationOpen} onClose={() => setIsCreateCurationOpen(false)} onSaved={curation => onCreated(curation.id)} />;
    $[24] = isCreateCurationOpen;
    $[25] = onCreated;
    $[26] = wave;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14) {
    t15 = <>{t12}{t13}{t14}</>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}